namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmFunkcniMistoKonfiguracniSkupina extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmFunkcniMistoKonfiguracniSkupinaReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmFunkcniMistoKonfiguracniSkupinaObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmFunkcniMistoKonfiguracniSkupinaObj());
            this.detailObj.createBase({
                contentName: "detailAdmFunkcniMistoKonfiguracniSkupina",
                contentCaption: "jres:33000371", //RC 33000371 : P�i�azen� fun. m�sto ke konf. skupin�
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmFunkcniMistoKonfiguracniSkupina", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmFunkcniMistoKonfiguracniSkupinaObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmFunkcniMistoKonfiguracniSkupinaReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["ixs_ins"]
        }

        setSxsDetail(): string {
            return this.data.ixs_fun + "#" + this.data.ixs_usr + "#";
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmFunkcniMistoKonfiguracniSkupinaSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            (this.cnt.isl.AdmFunkcniMistoKonfiguracniSkupina.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase();
                    this.showSuccessSave(close);
                    if (close == true) {
                        this.closeAction(true).done(() => { this.cnt.close() });
                    } else
                        this.reloadDataBase();
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.showBaseError();
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            this.openDetailOrModalWindow("Gordic.Adm.WebControls.DetailAdmFunkcniMistoKonfiguracniSkupina", filterObj, dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmFunkcniMistoKonfiguracniSkupina.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1} x {2}".format(this.options.contentCaption, (this.data.ixs_usr_txt) ? this.data.ixs_usr_txt : "", (this.data.ixs_fun_txt) ? this.data.ixs_fun_txt : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.MakeSelectField("ico", Gordic.Prefabs.Select.ginsico(), { model: "model.ico=value.ico" });
            this.MakeSelectField("ixs_fun", Gordic.Prefabs.Select.ginsfun(), {
                model: "model.ico=>value.ico,model.ixs_fun=value.ixs_fun",
                serverFilters: { aktivita: null, ico: new Gordic.Forms.Dependency("ico", "ico", true, false, this.cnt.element) },
                dropdown: false,
                flag: { text: "jres:32131150", state: 'important' },
            });
            this.MakeSelectField("ixs_usr", Gordic.Prefabs.Select.ginsusr(), { model: "model.ixs_usr=value.ixs_usr", dropdown: false, flag: { text: "jres:32131150", state: 'important' } });
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }
    }
}